<div mat-dialog-content>
    <div class="mat-dialog-content">
        <div class="head-key-modal-list">
            <h2>Deseja excluir esta Chave?</h2>
         </div>
         
         <div class="body-key-modal-list">
             Ao fazer a exclusão, a clínica perderá o acesso através desta chave e o procedimento é irreversível
         </div>
         <div class="footer-key-modal-list">
            <button mat-button class="btn-primary block" (click)="clickDelete()">
                <span *ngIf="isLoading == false">Sim, excluir</span>
                <mat-spinner [diameter]="30" class="mat-spinner-btn" *ngIf="isLoading == true"></mat-spinner>
            </button>
            <button mat-button class="btn-secundary block"(click)="clickCancel()">Cancelar</button>
        </div>
    </div>
</div>
